export interface Course {
  id: string;
  title: string;
  description: string;
  category: string;
  difficulty: string;
  difficultyColor: string;
  hours: string;
  lessons: string;
  students: string;
  rating: string;
  price: string;
  image: string;
  slug: string;
}

export const courses: Course[] = [
  {
    id: '1',
    title: 'ChatGPT & Prompt Engineering Mastery',
    description: 'Master the art of prompting to get superhuman results from ChatGPT and other LLMs.',
    category: 'ChatGPT',
    difficulty: 'Beginner',
    difficultyColor: 'bg-accent-100 text-accent-800',
    hours: '6 hours',
    lessons: '42 lessons',
    students: '12,400',
    rating: '4.9',
    price: '$49',
    image: 'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&q=80',
    slug: '/courses/chatgpt-mastery',
  },
  {
    id: '2',
    title: 'Machine Learning Foundations',
    description: 'Build a rock-solid understanding of ML algorithms, training pipelines, and model evaluation.',
    category: 'Machine Learning',
    difficulty: 'Intermediate',
    difficultyColor: 'bg-primary-100 text-primary-800',
    hours: '14 hours',
    lessons: '78 lessons',
    students: '8,900',
    rating: '4.8',
    price: '$89',
    image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800&q=80',
    slug: '/courses/ml-foundations',
  },
  {
    id: '3',
    title: 'Building AI Agents & Automation',
    description: 'Design and deploy autonomous AI agents that can browse, code, and complete complex tasks.',
    category: 'AI Agents',
    difficulty: 'Advanced',
    difficultyColor: 'bg-foreground-100 text-foreground-800',
    hours: '10 hours',
    lessons: '55 lessons',
    students: '5,600',
    rating: '4.9',
    price: '$119',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&q=80',
    slug: '/courses/ai-agents',
  },
  {
    id: '4',
    title: 'AI for Developers: APIs to Production',
    description: 'Integrate AI into your apps using OpenAI, Anthropic, and open-source models.',
    category: 'AI for Developers',
    difficulty: 'Intermediate',
    difficultyColor: 'bg-primary-100 text-primary-800',
    hours: '12 hours',
    lessons: '65 lessons',
    students: '9,200',
    rating: '4.8',
    price: '$99',
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&q=80',
    slug: '/courses/ai-for-devs',
  },
];

export const categories = ['All', 'ChatGPT', 'Machine Learning', 'AI Agents', 'AI for Developers'];